import { render, staticRenderFns } from "./detailsLamp.vue?vue&type=template&id=3f3ee044&scoped=true"
import script from "./detailsLamp.vue?vue&type=script&lang=js"
export * from "./detailsLamp.vue?vue&type=script&lang=js"
import style0 from "./detailsLamp.vue?vue&type=style&index=0&id=3f3ee044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3ee044",
  null
  
)

export default component.exports